/* WF v28/v29 (18./19.10.2026): läuft sofort im <head> (ohne defer), nur ein paar Zeilen.
   a) Kategorieseiten mit Chips (Teil 12 in theme.liquid): Platz für die Chips vorab reservieren
      und die Beschreibung oben gar nicht erst zeigen (sie wird per JS unter die Produkte verschoben).
      Liste = gleiche Handles wie Teil 12 in layout/theme.liquid.
   b) Produktseite: merken, ob der Link ursprünglich ?variant= hatte (das Theme schreibt die Variante
      später selbst in die URL). Nur dann darf die Galerie beim Laden zum Variantenbild springen.
      Bei ?variant= erstes Galeriebild vorab nicht zeigen (sonst kurz falsches Rad).
   c) WF v31 (19.10.2026): Bilder im Megamenü (sections/header.liquid) haben loading="lazy" und
      bremsen den Seitenaufbau nicht mehr. Damit sie beim ersten Aufklappen sofort da sind, werden sie
      kurz nach dem vollständigen Laden der Seite im Hintergrund geladen. */
(function () {
  try {
    var css = '';
    var path = location.pathname;
    var m = path.match(/\/collections\/([^\/?#]+)\/?$/);
    if (m) {
      var h = decodeURIComponent(m[1]);
      var list = ['neue-e-bikes', 'himiway-e-bikes', 'ado-e-bikes', 'urtopia-e-bikes', 'kemoway-e-bikes', 'e-bikes', 'e-bikes-trekking', 'e-bikes-mountainbike', 'e-bikes-city', 'e-gravelbikes'];
      if (list.indexOf(h) > -1) {
        css += '.template-collection .collection_img:not(:has(+ .wf-chips)){margin-bottom:59px}' +
          '@media (min-width:768px){.template-collection .collection_img:not(:has(+ .wf-chips)){margin-bottom:68px}}' +
          '.template-collection .collection_desc:not(.wf-desc-bottom){display:none}';
      }
    }
    window.__wfVarUrl = path.indexOf('/products/') > -1 && /[?&]variant=\d+/.test(location.search);
    if (window.__wfVarUrl) {
      css += '.section_single-product .type_carousel .gallery_big:not(.swiper-container-horizontal) .swiper-slide:first-child img{opacity:0!important}';
    }
    if (css) {
      var st = document.createElement('style');
      st.id = 'wf-early-css';
      st.appendChild(document.createTextNode(css));
      (document.head || document.documentElement).appendChild(st);
    }
  } catch (e) {}
  try {
    window.addEventListener('load', function () {
      setTimeout(function () {
        var imgs = document.querySelectorAll('#megamenu img[loading="lazy"]');
        for (var i = 0; i < imgs.length; i++) {
          var im = new Image();
          im.src = imgs[i].currentSrc || imgs[i].src;
          imgs[i].loading = 'eager';
        }
      }, 2000);
    });
  } catch (e) {}
})();
